@if(itemChannelsFormReady() && itemChannelsForm) {
    <form autocomplete="off" [formGroup]="itemChannelsForm"
        class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <ng-container formArrayName="channels">
            @for(channel of itemChannelsFormService.channelsArray?.controls; track $index) {
                <div [formGroupName]="$index" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
                    <div class="tw-flex tw-items-center tw-gap-3 md:tw-col-span-4 lg:tw-col-span-3">
                        <mat-slide-toggle formControlName="_enabled"></mat-slide-toggle>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                            <img [src]="itemChannelsFormService.getImgUrl($index)?.value" class="item-channel-icon tw-flex-none" 
                                (error)="onImageError($event)" alt="{{ itemChannelsFormService.getName($index)?.value }}">
                            <span class="tw-truncate tw-font-medium"
                                [appTruncatedText]="itemChannelsFormService.getName($index)?.value"
                            >{{itemChannelsFormService.getName($index)?.value}}</span>
                        </div>
                    </div>
                    <mat-form-field class="md:tw-col-span-8 lg:tw-col-span-9" 
                        [ngClass]="{'tw-hidden md:tw-block md:tw-invisible': itemChannelsFormService.getReadOnly($index)?.value,
                            'tw-block': !itemChannelsFormService.getReadOnly($index)?.value}">
                        <mat-label>{{ 'ITEMS.DETAILS.PRICELIST' | translate }}</mat-label>
                        <mat-select formControlName="default_pricelist" [disabled]="!itemChannelsFormService.getEnabled($index)?.value">
                            @for(price of priceList; track price.index) {
                                <mat-option [value]="price.index">{{price.value}} {{getItemPriceString(price.priceFieldName)}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }
        </ng-container>
    </form>
}
